import {Button} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from "@mui/icons-material/Share";
import Card from "../atoms/Cards/Card";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from '@mui/material/styles';
import FileCopyIcon from "@mui/icons-material/FileCopy";
import CopyAllIcon from '@mui/icons-material/CopyAll';

const DeleteIcon = styled(CloseIcon)({
  transform: 'scale(0.9)',
  color: 'red',
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 10,
  cursor: 'pointer',
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
});

const KiteContainer = styled('div')({
  position: 'relative',
  width: '170px',
  '&:hover': {
    '& .delete-icon': {
      opacity: 1,
    }
  }
});

export const Kite = ({kite, deleteKite, cloneKite, editKite=true, siteNormalName}) => {
  return <Card>
    <KiteContainer>
      {deleteKite && <DeleteIcon className="delete-icon" fontSize={'small'} onClick={(e) => deleteKite(e, kite)}/> }
      <div style={{fontSize: 16, fontWeight: 'bold'}}>{kite.name}</div>
      <div  style={{fontSize: 12, marginTop:3}}>Target <b>{kite.targetCustomer}</b></div>
      <div style={{
        borderTop:'1px solid #eee',
        marginTop:12,
        paddingTop:6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'baseline'
      }}>
        {cloneKite && <Button
                size="small"
                startIcon={<FileCopyIcon />}
                onClick={(e) => cloneKite(e, kite)}
        >
          Clone
        </Button>}

        {cloneKite && kite.type !== 'template' && <Button
                size="small"
                startIcon={<CopyAllIcon />}
                onClick={(e) => cloneKite(e, kite, true)}
        >
          Make Template
        </Button>}

        {editKite && <Button
          href={`${process.env.REACT_APP_KITE_URL}/edit/${kite._id}`}
          target={kite._id}
          size={'small'}
          startIcon={<EditIcon />}
        >Edit</Button>}

        {editKite && siteNormalName && <Button
          href={`${process.env.REACT_APP_KITE2_URL}/${siteNormalName}/${kite._id}`}
          target={kite._id}
          size={'small'}
          startIcon={<EditIcon />}
        >Edit 2</Button>}

        <Button href={`${process.env.REACT_APP_KITE_URL}/kitecampaign/${kite._id}`}
                target={`${kite._id}_live`}
                size="small"
                startIcon={<ShareIcon />}
        >
          Live Link
        </Button>
      </div>
    </KiteContainer>
  </Card>
}
